type Translation = {
	"Modifications detected, do you want to discard and close?": string;
	"Delete template": string;
	"of type": string;
	"Discard your changes?": string;
	'Replace "{0}"?': string;
	"An error occurred": string;
	"Could not open view.": string;
	"Performing maintenance, please wait…": string;
	"Your browser is not supported. Proceed with caution.": string;
	Username: string;
	Password: string;
	"Change password": string;
	"Remember me": string;
	"Log in anonymously": string;
	"Log in": string;
	"Login failed: username and/or password is incorrect.": string;
	"Unexpected error": string;
	"The error has been reported. Refresh your browser before continuing.": string;
	"Check your internet connection.": string;
	"Not all subcollections duplicated": string;
	"{0} have not been duplicated because it contains too many items.": string;
	"{0} have not been duplicated because its items could not be retrieved.": string;
	"Invalid context {0}": string;
	"The view does not exist {0} {1}": string;
	"The view doest not match the type of the id.": string;
	"The URL might be wrong. {0}": string;
	"Cannot requery": string;
	"Download failed": string;
	"Entry does not exist (anymore).": string;
	"Permission denied.": string;
	"Incomplete file name": string;
	"Not all values of the file name could be retreived.": string;
	"Cannot initialize command": string;
	"Matrix '{0}' candidates could not be initialized. {1}": string;
	"Could not reset password": string;
	"No permission to reset password.": string;
	"Can not reset password.": string;
	"Username is unknown.": string;
	"Can not send password": string;
	"Reset the password.": string;
	"Password reset link copied to clipboard": string;
	"Can't copy password": string;
	"Clipboard is not supported.": string;
	"Failed to write to the clipboard.": string;
	"Not all subcollections copied": string;
	"{0} have not been copied because it contains too many items.": string;
	"{0} have not been copied because its items could not be retrieved.": string;
	"Cannot upload file": string;
	"The file can not be uploaded because the property is not editable.": string;
	"Window is not intialized.": string;
	"Window '{0}' is not initialized.": string;
	"Cannot add entry": string;
	"The reference is not resolved. Try again later": string;
	"The link is not resolved. Try again later": string;
	"Failed to import file": string;
	"Sucessfully imported CSV file": string;
	"Cannot open new window": string;
	"Save the entry, then try again.": string;
	"Cannot copy link": string;
	"Save the entry first, then try again": string;
	"Item not removed": string;
	"Cannot delete item": string;
	"Something went wrong.": string;
	"Could not remove {0} from {1} because it has blocking dependencies.": string;
	"Could not remove {0} from {1} because it does not exist in backend.": string;
	"Could not remove {0} from {1} because you're not allowed to read it.": string;
	"Could not remove {0} from {1}. Cause: {2}": string;
	"The key is unknown.": string;
	"Cannot remove the root": string;
	"Duplication not allowed": string;
	"Can not duplicate the root.": string;
	"You do not have the sufficient rights to perform this operation.": string;
	"Cannot duplicate this item.": string;
	"Parameter not set": string;
	"Unable to resolve": string;
	"This reference depends on another reference that is not yet set. Set that reference and try again.": string;
	"Unable to resolve this reference: {0}": string;
	"This link depends on another link that is not set.": string;
	"Invalid parameters": string;
	"Check all fields and try again.": string;
	"Item does not exist.": string;
	"The reference {0} is not set.": string;
	"The reference {0} is not readable.": string;
	"The reference {0} output {1} is not readable.": string;
	"The state constraint {0} is not readable.": string;
	"The stategroup {0} output parameter {1} is not readable.": string;
	"Failed to duplicate entry": string;
	"Entry doesnt exist anymore...": string;
	"Failed to query entries.": string;
	"Failed to query entries for linked node mapping '{0}'.": string;
	"Linked item not found": string;
	"Cannot open item": string;
	"The item cannot be found.": string;
	"Unable to find entry": string;
	"Text filter limit exceeded.": string;
	"Could not download report {0}": string;
	"Reopen the view and try again.": string;
	"Cannot upload template": string;
	"Cannot read template": string;
	"Upload the file again.": string;
	"Changes not saved": string;
	"There are invalid fields remaining. Check all fields and try again.": string;
	"Item not saved": string;
	"Parent item removed.": string;
	"Permission denied. Permissions may have changed while you were editing. Try saving again.": string;
	"Item cannot be saved, the datastore did not accept your changes.": string;
	"Datastore update failed.": string;
	"Can not rename the entry.": string;
	"Breaks linear order.": string;
	"Name is not valid or already in use.": string;
	"Cannot select reference": string;
	"Cannot reset password.": string;
	"The username changed.": string;
	"Could not determine inline view": string;
	"hour (short)": string;
	"minutes (short)": string;
	"seconds (short)": string;
	"out of range": string;
	"Add entry not allowed": string;
	"The application is updated": string;
	"Can't download report because the parameters are invalid": string;
	"Unable to put item in order": string;
	"Unable to reorder items.": string;
	"The CSV file is not valid. Refer to the error report and try again.": string;
	"Something went wrong. Please try again.": string;
	"The file name '{0}' is invalid.": string;
	"The file '{0}' already exists.": string;
	"Server announcement": string;
	"There are unsaved changes which might be overwritten. Are you sure you want to continue?": string;
	"Imported CSV file": string;
	"Not all changes have been saved. Please review and save again.": string;
	"Changes have been saved": string;
	"Did not complete operation": string;
	"The operation was lost before it was completed": string;
	"Updated scheduled": string;
};
type Translations = {
	english: Translation;
	dutch: Translation;
};
export type TranslationKey = keyof Translation;
export type Languages = keyof Translations;

const translations: Translations = {
	english: {
		"Modifications detected, do you want to discard and close?":
			"Modifications detected, do you want to discard and close?",
		"Delete template": "Delete template",
		"of type": "of type",
		"Discard your changes?": "Discard your changes?",
		'Replace "{0}"?': 'Replace "{0}"?',
		"An error occurred": "An error occurred",
		"Could not open view.": "Could not open view.",
		"Performing maintenance, please wait…": "Performing maintenance, please wait…",
		"Your browser is not supported. Proceed with caution.": "Your browser is not supported. Proceed with caution.",
		Username: "Username",
		Password: "Password",
		"Change password": "Change password",
		"Remember me": "Remember me",
		"Log in anonymously": "Log in anonymously",
		"Log in": "Log in",
		"Login failed: username and/or password is incorrect.": "Login failed: username and/or password is incorrect.",
		"Unexpected error": "Unexpected error",
		"The error has been reported. Refresh your browser before continuing.":
			"The error has been reported. Refresh your browser before continuing.",
		"Check your internet connection.": "Check your internet connection.",
		"Not all subcollections duplicated": "Not all subcollections duplicated",
		"{0} have not been duplicated because it contains too many items.":
			"{0} have not been duplicated because it contains too many items.",
		"{0} have not been duplicated because its items could not be retrieved.":
			"{0} have not been duplicated because its items could not be retrieved.",
		"Invalid context {0}": "Invalid context {0}",
		"The view does not exist {0} {1}": "The view does not exist {0} {1}",
		"The view doest not match the type of the id.": "The view doest not match the type of the id.",
		"The URL might be wrong. {0}": "The URL might be wrong. {0}",
		"Cannot requery": "Cannot requery",
		"Download failed": "Download failed",
		"Entry does not exist (anymore).": "Entry does not exist (anymore).",
		"Permission denied.": "Permission denied.",
		"Incomplete file name": "Incomplete file name",
		"Not all values of the file name could be retreived.": "Not all values of the file name could be retreived.",
		"Cannot initialize command": "Cannot initialize command",
		"Matrix '{0}' candidates could not be initialized. {1}": "Matrix '{0}' candidates could not be initialized. {1}",
		"Could not reset password": "Could not reset password",
		"No permission to reset password.": "No permission to reset password.",
		"Can not reset password.": "Can not reset password.",
		"Username is unknown.": "Username is unknown.",
		"Can not send password": "Can not send password",
		"Reset the password.": "Reset the password.",
		"Password reset link copied to clipboard": "Password reset link copied to clipboard",
		"Can't copy password": "Can't copy password",
		"Clipboard is not supported.": "Clipboard is not supported.",
		"Failed to write to the clipboard.": "Failed to write to the clipboard.",
		"Not all subcollections copied": "Not all subcollections copied",
		"{0} have not been copied because it contains too many items.":
			"{0} have not been copied because it contains too many items.",
		"{0} have not been copied because its items could not be retrieved.":
			"{0} have not been copied because its items could not be retrieved.",
		"Cannot upload file": "Cannot upload file",
		"The file can not be uploaded because the property is not editable.":
			"The file can not be uploaded because the property is not editable.",
		"Window is not intialized.": "Window is not intialized.",
		"Window '{0}' is not initialized.": "Window '{0}' is not initialized.",
		"Cannot add entry": "Cannot add entry",
		"The reference is not resolved. Try again later": "The reference is not resolved. Try again later",
		"The link is not resolved. Try again later": "The link is not resolved. Try again later",
		"Failed to import file": "Failed to import file",
		"Sucessfully imported CSV file": "Sucessfully imported CSV file",
		"Cannot open new window": "Cannot open new window",
		"Save the entry, then try again.": "Save the entry, then try again.",
		"Cannot copy link": "Cannot copy link",
		"Save the entry first, then try again": "Save the entry first, then try again",
		"Item not removed": "Item not removed",
		"Cannot delete item": "Cannot delete item",
		"Something went wrong.": "Something went wrong.",
		"Could not remove {0} from {1} because it has blocking dependencies.":
			"Could not remove {0} from {1} because it has blocking dependencies.",
		"Could not remove {0} from {1} because it does not exist in backend.":
			"Could not remove {0} from {1} because it does not exist in backend.",
		"Could not remove {0} from {1} because you're not allowed to read it.":
			"Could not remove {0} from {1} because you're not allowed to read it.",
		"Could not remove {0} from {1}. Cause: {2}": "Could not remove {0} from {1}. Cause: {2}",
		"The key is unknown.": "The key is unknown.",
		"Cannot remove the root": "Cannot remove the root",
		"Duplication not allowed": "Duplication not allowed",
		"Can not duplicate the root.": "Can not duplicate the root.",
		"You do not have the sufficient rights to perform this operation.":
			"You do not have the sufficient rights to perform this operation.",
		"Cannot duplicate this item.": "Cannot duplicate this item.",
		"Parameter not set": "Parameter not set",
		"Unable to resolve": "Unable to resolve",
		"This reference depends on another reference that is not yet set. Set that reference and try again.":
			"This reference depends on another reference that is not yet set. Set that reference and try again.",
		"Unable to resolve this reference: {0}": "Unable to resolve this reference: {0}",
		"This link depends on another link that is not set.": "This link depends on another link that is not set.",
		"Invalid parameters": "Invalid parameters",
		"Check all fields and try again.": "Check all fields and try again.",
		"Item does not exist.": "Item does not exist.",
		"The reference {0} is not set.": "The reference {0} is not set.",
		"The reference {0} is not readable.": "The reference {0} is not readable.",
		"The reference {0} output {1} is not readable.": "The reference {0} output {1} is not readable.",
		"The state constraint {0} is not readable.": "The state constraint {0} is not readable.",
		"The stategroup {0} output parameter {1} is not readable.":
			"The stategroup {0} output parameter {1} is not readable.",
		"Failed to duplicate entry": "Failed to duplicate entry",
		"Entry doesnt exist anymore...": "Entry doesnt exist anymore...",
		"Failed to query entries.": "Failed to query entries.",
		"Failed to query entries for linked node mapping '{0}'.": "Failed to query entries for linked node mapping '{0}'.",
		"Linked item not found": "Linked item not found",
		"Cannot open item": "Cannot open item",
		"The item cannot be found.": "The item cannot be found.",
		"Unable to find entry": "Unable to find entry",
		"Text filter limit exceeded.": "Text filter limit exceeded.",
		"Could not download report {0}": "Could not download report {0}",
		"Reopen the view and try again.": "Reopen the view and try again.",
		"Cannot upload template": "Cannot upload template",
		"Cannot read template": "Cannot read template",
		"Upload the file again.": "Upload the file again.",
		"Changes not saved": "Changes not saved",
		"There are invalid fields remaining. Check all fields and try again.":
			"There are invalid fields remaining. Check all fields and try again.",
		"Item not saved": "Item not saved",
		"Parent item removed.": "Parent item removed.",
		"Permission denied. Permissions may have changed while you were editing. Try saving again.":
			"Permission denied. Permissions may have changed while you were editing. Try saving again.",
		"Item cannot be saved, the datastore did not accept your changes.":
			"Item cannot be saved, the datastore did not accept your changes.",
		"Datastore update failed.": "Datastore update failed.",
		"Can not rename the entry.": "Can not rename the entry.",
		"Breaks linear order.": "Breaks linear order.",
		"Name is not valid or already in use.": "Name is not valid or already in use.",
		"Cannot select reference": "Cannot select reference",
		"Cannot reset password.": "Cannot reset password.",
		"The username changed.": "The username changed.",
		"Could not determine inline view": "Could not determine inline view",
		"hour (short)": "h",
		"minutes (short)": "m",
		"seconds (short)": "s",
		"out of range": "out of range",
		"Add entry not allowed": "Add entry not allowed",
		"The application is updated": "The application is updated",
		"Can't download report because the parameters are invalid":
			"Can't download report because the parameters are invalid",
		"Unable to put item in order": "Unable to put item in order",
		"Unable to reorder items.": "Unable to reorder items.",
		"The CSV file is not valid. Refer to the error report and try again.":
			"The CSV file is not valid. Refer to the error report and try again.",
		"Something went wrong. Please try again.": "Something went wrong. Please try again.",
		"The file name '{0}' is invalid.": "The file name '{0}' is invalid.",
		"The file '{0}' already exists.": "The file '{0}' already exists.",
		"Server announcement": "Server announcement",
		"There are unsaved changes which might be overwritten. Are you sure you want to continue?":
			"There are unsaved changes which might be overwritten. Are you sure you want to continue?",
		"Imported CSV file": "Imported CSV file",
		"Not all changes have been saved. Please review and save again.":
			"Not all changes have been saved. Please review and save again.",
		"Changes have been saved": "Changes have been saved",
		"Did not complete operation": "Did not complete operation",
		"The operation was lost before it was completed": "The operation was lost before it was completed",
		"Updated scheduled": "Updated scheduled",
	},
	dutch: {
		"Modifications detected, do you want to discard and close?":
			"Er zijn aanpassingen gemaakt, wilt u deze ongedaan maken en het scherm sluiten?",
		"Delete template": "Verwijder template",
		"of type": "van type",
		"Discard your changes?": "Wijzigingen ongedaan maken?",
		'Replace "{0}"?': 'Vervang "{0}"?',
		"An error occurred": "Er is iets fout gegaan",
		"Could not open view.": "Kon het scherm niet openen.",
		"Performing maintenance, please wait…": "Onderhoud wordt uitgevoerd. Even geduld…",
		"Your browser is not supported. Proceed with caution.":
			"Uw browser wordt niet ondersteund. Ga verder op eigen risico.",
		Username: "Gebruikersnaam",
		Password: "Wachtwoord",
		"Change password": "Wachtwoord wijzigen",
		"Remember me": "Onthoud mij",
		"Log in anonymously": "Anoniem inloggen",
		"Log in": "Log in",
		"Login failed: username and/or password is incorrect.":
			"Inloggen mislukt: gebruikersnaam en/of wachtwoord is niet correct.",
		"Unexpected error": "Onverwachte fout",
		"The error has been reported. Refresh your browser before continuing.":
			"De fout is gerapporteerd. Ververs je browser voordat je verder gaat.",
		"Check your internet connection.": "Controleer je internetverbinding.",
		"Not all subcollections duplicated": "Niet alle subcollecties zijn gedupliceerd",
		"{0} have not been duplicated because it contains too many items.":
			"{0} is niet gedupliceerd omdat het te veel items bevat.",
		"{0} have not been duplicated because its items could not be retrieved.":
			"{0} zijn niet gedupliceerd omdat de items niet konden worden opgehaald.",
		"Invalid context {0}": "Ongeldige context {0}",
		"The view does not exist {0} {1}": "De weergave bestaat niet {0} {1}",
		"The view doest not match the type of the id.": "De weergave komt niet overeen met het type id.",
		"The URL might be wrong. {0}": "De URL is mogelijk onjuist. {0}",
		"Cannot requery": "Kan gegevens niet ophalen",
		"Download failed": "Download mislukt",
		"Entry does not exist (anymore).": "Invoer bestaat niet (meer).",
		"Permission denied.": "Geen toestemming.",
		"Incomplete file name": "Onvolledige bestandsnaam",
		"Not all values of the file name could be retreived.":
			"Niet alle waarden van de bestandsnaam kunnen worden achterhaald.",
		"Cannot initialize command": "Kan opdracht niet initialiseren",
		"Matrix '{0}' candidates could not be initialized. {1}":
			"Kandidaten voor matrix '{0}' konden niet worden geïnitialiseerd. {1}",
		"Could not reset password": "Kon wachtwoord niet opnieuw instellen",
		"No permission to reset password.": "Geen toestemming om het wachtwoord opnieuw in te stellen.",
		"Can not reset password.": "Kan wachtwoord niet opnieuw instellen.",
		"Username is unknown.": "Gebruikersnaam is onbekend.",
		"Can not send password": "Kan geen wachtwoord verzenden",
		"Reset the password.": "Stel het wachtwoord opnieuw in.",
		"Password reset link copied to clipboard": "Wachtwoord reset link gekopieerd naar klembord",
		"Can't copy password": "Kan wachtwoord niet kopiëren",
		"Clipboard is not supported.": "Klembord wordt niet ondersteund.",
		"Failed to write to the clipboard.": "Kan niet naar het klembord schrijven.",
		"Not all subcollections copied": "Niet alle subcollecties gekopieerd",
		"{0} have not been copied because it contains too many items.":
			"{0} zijn niet gekopieerd omdat het te veel items bevat.",
		"{0} have not been copied because its items could not be retrieved.":
			"{0} zijn niet gekopieerd omdat de items niet konden worden opgehaald.",
		"Cannot upload file": "Kan bestand niet uploaden",
		"The file can not be uploaded because the property is not editable.":
			"Het bestand kan niet worden geüpload omdat de eigenschap niet kan worden bewerkt.",
		"Window is not intialized.": "Venster is niet geïnitialiseerd.",
		"Window '{0}' is not initialized.": "Venster '{0}' is niet geïnitialiseerd.",
		"Cannot add entry": "Kan geen invoer toevoegen",
		"The reference is not resolved. Try again later": "De referentie is niet gevonden. Probeer het later opnieuw",
		"The link is not resolved. Try again later": "De link is niet gevonden. Probeer het later opnieuw",
		"Failed to import file": "Importeren van bestand mislukt",
		"Sucessfully imported CSV file": "CSV-bestand is succesvol geïmporteerd",
		"Cannot open new window": "Kan geen nieuw venster openen",
		"Save the entry, then try again.": "Sla het item op en probeer het opnieuw.",
		"Cannot copy link": "Kan link niet kopiëren",
		"Save the entry first, then try again": "Sla de invoer eerst op en probeer het opnieuw",
		"Item not removed": "Artikel niet verwijderd",
		"Cannot delete item": "Kan item niet verwijderen",
		"Something went wrong.": "Er is iets fout gegaan.",
		"Could not remove {0} from {1} because it has blocking dependencies.":
			"Kon {0} niet verwijderen uit {1} omdat het blokkerende afhankelijkheden heeft.",
		"Could not remove {0} from {1} because it does not exist in backend.":
			"Kon {0} niet verwijderen uit {1} omdat het niet bestaat op de server.",
		"Could not remove {0} from {1} because you're not allowed to read it.":
			"Kon {0} niet verwijderen uit {1} omdat u geen leesrechten heeft.",
		"Could not remove {0} from {1}. Cause: {2}": "Kon {0} niet verwijderen uit {1}. Oorzaak: {2}",
		"The key is unknown.": "De sleutel is onbekend.",
		"Cannot remove the root": "Kan de root niet verwijderen",
		"Duplication not allowed": "Duplicatie niet toegestaan",
		"Can not duplicate the root.": "Kan de root niet dupliceren.",
		"You do not have the sufficient rights to perform this operation.":
			"U hebt niet voldoende rechten om deze bewerking uit te voeren.",
		"Cannot duplicate this item.": "Kan dit item niet dupliceren.",
		"Parameter not set": "Parameter niet ingevoerd",
		"Unable to resolve": "Niet kunnen vinden",
		"This reference depends on another reference that is not yet set. Set that reference and try again.":
			"Deze referentie is afhankelijk van een andere referentie die nog niet is ingevoerd. Voer die referentie in en probeer het opnieuw.",
		"Unable to resolve this reference: {0}": "Kan deze referentie niet gevonden: {0}",
		"This link depends on another link that is not set.":
			"Deze link is afhankelijk van een andere link die niet is ingevoerd.",
		"Invalid parameters": "ongeldige parameters",
		"Check all fields and try again.": "Controleer alle velden en probeer het opnieuw.",
		"Item does not exist.": "Artikel bestaat niet.",
		"The reference {0} is not set.": "De referentie {0} is niet ingevoerd.",
		"The reference {0} is not readable.": "De referentie {0} is niet leesbaar.",
		"The reference {0} output {1} is not readable.": "De referentie {0} output {1} is niet leesbaar.",
		"The state constraint {0} is not readable.": "De state constraint {0} is niet leesbaar.",
		"The stategroup {0} output parameter {1} is not readable.":
			"De stategroup {0} output parameter {1} is niet leesbaar.",
		"Failed to duplicate entry": "Kan item niet dupliceren",
		"Entry doesnt exist anymore...": "Entry bestaat niet meer ...",
		"Failed to query entries.": "Zoeken naar items is mislukt.",
		"Failed to query entries for linked node mapping '{0}'.":
			"Zoeken naar items voor linked node mapping '{0}' is mislukt.",
		"Linked item not found": "Gekoppeld artikel niet gevonden",
		"Cannot open item": "Kan item niet openen",
		"The item cannot be found.": "Het artikel kan niet gevonden worden.",
		"Unable to find entry": "Kan vermelding niet vinden",
		"Text filter limit exceeded.": "Tekstfilterlimiet overschreden.",
		"Could not download report {0}": "Kan rapport {0} niet downloaden",
		"Reopen the view and try again.": "Open de weergave opnieuw en probeer het opnieuw.",
		"Cannot upload template": "Kan sjabloon niet uploaden",
		"Cannot read template": "Kan sjabloon niet lezen",
		"Upload the file again.": "Upload het bestand opnieuw.",
		"Changes not saved": "Wijzigingen niet opgeslagen",
		"There are invalid fields remaining. Check all fields and try again.":
			"Er zijn nog ongeldige velden. Controleer alle velden en probeer het opnieuw.",
		"Item not saved": "Item niet opgeslagen",
		"Parent item removed.": "Bovenliggend item verwijderd.",
		"Permission denied. Permissions may have changed while you were editing. Try saving again.":
			"Geen toestemming. Toestemmingen kunnen zijn gewijzigd tijdens het bewerken. Probeer opnieuw op te slaan.",
		"Item cannot be saved, the datastore did not accept your changes.":
			"Item kan niet worden opgeslagen, de datastore heeft uw wijzigingen niet geaccepteerd.",
		"Datastore update failed.": "Datastore-update mislukt.",
		"Can not rename the entry.": "Kan het item niet hernoemen.",
		"Breaks linear order.": "Breekt lineaire volgorde.",
		"Name is not valid or already in use.": "Naam is niet geldig of is al in gebruik.",
		"Cannot select reference": "Referentie kan niet worden geselecteerd",
		"Cannot reset password.": "Kan wachtwoord niet opnieuw instellen.",
		"The username changed.": "De gebruikersnaam is gewijzigd.",
		"Could not determine inline view": "Kan inline weergave niet bepalen",
		"hour (short)": "u",
		"minutes (short)": "m",
		"seconds (short)": "s",
		"out of range": "buiten bereik",
		"Add entry not allowed": "Invoer toevoegen niet toegestaan",
		"The application is updated": "De applicatie is bijgewerkt",
		"Can't download report because the parameters are invalid":
			"Het rapport kan niet worden gedownload. De parameters zijn niet valide.",
		"Unable to put item in order": "Kan het item niet op volgorde zetten",
		"Unable to reorder items.": "Kan items niet opnieuw ordenen",
		"The CSV file is not valid. Refer to the error report and try again.":
			"Het CSV-bestand is niet valide. Raadpleeg het foutenrapport en probeer het opnieuw.",
		"Something went wrong. Please try again.": "Er is een fout opgetreden. Probeer het opnieuw.",
		"The file name '{0}' is invalid.": "De bestandsnaam '{0}' is niet valide.",
		"The file '{0}' already exists.": "Het bestand met de naam '{0}' bestaat al.",
		"Server announcement": "Servermelding",
		"There are unsaved changes which might be overwritten. Are you sure you want to continue?":
			"Er zijn niet-opgeslagen wijzigingen die kunnen worden overschreven. Weet je zeker dat je door wilt gaan?",
		"Imported CSV file": "CSV-bestand is geïmporteerd",
		"Not all changes have been saved. Please review and save again.":
			"Niet alle aanpassingen zijn opgeslagen. Controleer en sla opnieuw op.",
		"Changes have been saved": "De wijzigingen zijn opgeslagen",
		"Did not complete operation": "Bewerking is niet voltooid",
		"The operation was lost before it was completed": "De bewerking ging verloren voordat deze was voltooid.",
		"Updated scheduled": "Update gepland",
	},
};

let active_translation: Translation;
export function setLanguage(language: Languages): void {
	active_translation = translations[language];
}
setLanguage("english");

export type FormatString = { phrase: TranslationKey; vars: string[] };

export function translate(text: TranslationKey | FormatString, language?: Languages): string {
	const selected_translation = language === undefined ? active_translation : translations[language];
	if (typeof text === "string") {
		return selected_translation[text];
	} else {
		let phrase = selected_translation[text.phrase];
		for (const v in text.vars) {
			phrase = phrase.replace("{" + v + "}", text.vars[v]);
		}
		return phrase;
	}
}
